export default "__VITE_ASSET__B$pp9ahh__"